// extracted by css-extract-rspack-plugin
export default {"cls1":"NewCitationPing-cls1_rrd","cls2":"NewCitationPing-cls2_ZmT NewCitationPing-cls1_rrd"};